import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { usersReportsColumns } from "../../../constant/tables-columns/tablesColums";
import { digitsThree } from "../../../utils/price";
import UserReportsFilter from "./UserReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";

export default function UsersReports() {
  const tableRequest = useTableRequest({ initialLoading: false });
  const [userReportsData, setUsersReportsData] = useState([]);

  const [filter, setFilter] = useState();

  const getProductReports = async (params) => {
    const path = "admin/reports/usersTotalSales";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUsersReportsData(response?.data?.result);
    });
  };

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  const data = [];

  userReportsData?.map((item) =>
    data.push({
      _ref_user_finalProductsPrice: digitsThree(item._ref_user_finalProductsPrice),
      _ref_user_totalProductsPrice: digitsThree(item._ref_user_totalProductsPrice),
      ordersTotalCount: digitsThree(item.ordersData.length),
      name: item?.name,
      mobile: item?.mobile,
      role: item?.role,
      id: item._id,
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-between items-center">
        <Title title={"گزارشات کاربران"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={data} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">فروش منتسب به کاربران را نشان می‌دهد. تاریخ، نقش و کاربر را انتخاب کنید و روی جستجو بزنید.</p>
      <UserReportsFilter
        filterDataHandler={filterDataHandler}
        activeSearchButton={!tableRequest.loading}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={usersReportsColumns} rows={data} />
    </div>
  );
}
